import { Dictionary } from "vue-router/types/router";

export class RouteUtils {
  public static getQueryParam(
    query: Dictionary<string | (string | null)[]>,
    name: string
  ): string {
    const value = query[name];

    if (Array.isArray(value)) {
      return value[0] ?? "";
    }

    return value === undefined || value === null ? "" : String(value);
  }
}
